import { css } from 'styled-components';

const zIndex = {
  // # 일반
  default: 1,
  /**
   *  헤드 바
   */
  mainHead: 10,
  /**
   *  이미지 업로드 toolbar
   */
  imgUploadToolBar: 20,
  /**
   *  하단 navbar
   */
  navbarFixedBottom: 1000,
  /**
   *  토스트 메시지
   */
  notifyToast: 1000,
  /**
   *  메인 스피너
   */
  screenLoader: 10000,
  /**
   * ant select dropdown
   */
  antSelectDropdown: 1050,
  /**
   * scroll navigator
   */
  scrollNavigator: 1,
} as const;

const ellipsis = css`
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const theme = {
  zIndex,
  ellipsis,
};

export type Theme = typeof theme;
export default theme;
